import { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

// Setup axios interceptor to attach Authorization header if token exists in localStorage
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('sankalp_token');
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('sankalp_token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true, headers });
      setUser(res.data.user);
    } catch (error) {
      setUser(null);
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    if (res.data?.token) {
      localStorage.setItem('sankalp_token', res.data.token);
    }
    setUser(res.data.user);
    return res.data;
  };

  const signup = async (name, email, phone_no, password, confirm_password) => {
    const res = await axios.post(`${API}/auth/signup`, 
      { name, email, phone_no, password, confirm_password },
      { withCredentials: true }
    );
    if (res.data?.token) {
      localStorage.setItem('sankalp_token', res.data.token);
    }
    setUser(res.data.user);
    return res.data;
  };

  const guestLogin = async () => {
    const res = await axios.post(`${API}/auth/guest`, {}, { withCredentials: true });
    if (res.data?.token) {
      localStorage.setItem('sankalp_token', res.data.token);
    }
    setUser(res.data.user);
    return res.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      // Ignore logout errors if backend unreachable
    }
    localStorage.removeItem('sankalp_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, guestLogin, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
